export default __webpack_public_path__ + "static/media/building-bg-icon.43da1907.svg";